import { makeObservable, observable } from 'mobx'
import type { DateStr } from 'src/types'

import { EMPTY_STRING_ID } from '@/constant/common'

import { DTO } from '../DTO'
import { SchoolGrade } from './SchoolGrade'
import type { Student } from './Student'

/***
 * 학생 상세 정보
 * @see StudentController
 ***/
export class StudentDetail extends DTO {
  id = EMPTY_STRING_ID
  loginId = ''
  name = ''
  attendanceCode = ''

  schoolGrade: {
    grade: 1 | 2 | 3 | 4 | 5 | 6
    schoolType: res.Student['schoolType']
  } = {
    grade: 1,
    schoolType: 'ELEMENTARY',
  }
  schoolName = ''
  email = ''
  address = ''
  phoneNumber = ''
  homePhoneNumber = ''
  memo = ''
  status: res.StudentDetail['status'] = 'ACTIVE'
  parent = { id: '', loginId: '', phoneNumber: '' }
  siblings: res.StudentDetail['siblings'] = []

  startDate: DateStr<'-'> | null = null
  birthDate: DateStr<'-'> | null = null
  isVirtual = false // 가상학생여부

  serviceTypes: res.StudentDetail['serviceTypes'] = []

  get isEnglishflatAllowed() {
    return this.serviceTypes.includes('ENGLISHFLAT')
  }

  constructor({
    schoolType,
    grade,
    ...data
  }: Partial<
    res.StudentDetail & Pick<res.Student, 'attendanceCode'> & Pick<Student, 'isVirtual'>
  > = {}) {
    super()
    if (data) {
      this.updateExceptNullable<StudentDetail>(data, {
        schoolGrade: new SchoolGrade({ schoolType, grade }),
      })
    }
    makeObservable(this, {
      attendanceCode: observable,
      isVirtual: observable,
    })
  }
}
